"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-named-as-default */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var SplitDialog_1 = __importDefault(require("../SplitDialog/SplitDialog"));
var Button_1 = __importDefault(require("../Button/Button"));
var PasswordStrengthMeter_1 = __importStar(require("./PasswordStrengthMeter"));
var functions_1 = __importDefault(require("../../functions/functions"));
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super.call(this) || this;
        _this.updateMethod = function (evt) {
            var _a;
            var _b = evt.target, name = _b.name, value = _b.value;
            var errors = {};
            var _c = _this.state, newPassword = _c.newPassword, confirmPassword = _c.confirmPassword;
            if (name === "newPassword") {
                newPassword = value;
                if (value !== _this.state.confirmPassword) {
                    errors.confirmPassword = "Passwords do not match";
                }
                if (PasswordStrengthMeter_1.getPasswordStrength(value).score < 75) {
                    errors.newPassword = "Password not strong enough";
                }
            }
            else if (name === "confirmPassword") {
                confirmPassword = value;
                if (value !== _this.state.newPassword) {
                    errors.confirmPassword = "Passwords do not match";
                }
                if (PasswordStrengthMeter_1.getPasswordStrength(_this.state.newPassword || "").score < 75) {
                    errors.newPassword = "Password not strong enough";
                }
            }
            var valid = !!_this.state.password &&
                newPassword === confirmPassword &&
                PasswordStrengthMeter_1.getPasswordStrength(newPassword || "").score > 74;
            _this.setState((_a = {}, _a[name] = value, _a.errors = errors, _a.valid = valid, _a));
        };
        _this.componentDidMount = function () {
            var jwt = _this.props.jwt;
            var parsedUser = functions_1.default(jwt);
            _this.setState({ parsedUser: parsedUser, jwt: jwt });
        };
        _this.submitNewPassword = function () {
            var _a, _b;
            var url = (_a = document.getElementById("apiUrl")) === null || _a === void 0 ? void 0 : _a.value;
            var isSysAdmin = ((_b = document.getElementById("react_isSysAdmin")) === null || _b === void 0 ? void 0 : _b.value) === "true";
            var getToken = function () {
                Promise.resolve(_this.state.jwt);
            };
            if (isSysAdmin) {
                getToken = function () {
                    return fetch(url + "/auth/login", {
                        method: "POST",
                        body: JSON.stringify({
                            username: _this.props.auditUserEmail,
                            password: _this.state.password,
                            clientId: 1001
                        })
                    })
                        .then(function (res) { return res.json(); })
                        .then(function (res) { return res.jwt; });
                };
            }
            _this.setState({ sending: true }, function () {
                getToken()
                    .then(function (res) {
                    return fetch(url + "/accounts/" + (isSysAdmin ? 1001 : _this.state.parsedUser.userclient) + "/" + (_this.props.auditUserId || _this.state.parsedUser.userid) + "/password", {
                        headers: {
                            "content-type": "application/json",
                            Authorization: "Bearer " + res
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email: _this.props.auditUserEmail || _this.state.parsedUser.username,
                            currentPassword: _this.state.password,
                            newPassword: _this.state.newPassword
                        })
                    });
                })
                    .then(function (res) { return res.json(); })
                    .then(function (res) {
                    if (res.error) {
                        throw new Error(res.error);
                    }
                    _this.setState({
                        sending: false,
                        valid: false,
                        errors: {},
                        newPassword: null,
                        confirmPassword: null,
                        password: null
                    }, function () {
                        _this.props.closeMethod();
                    });
                })
                    .catch(function (error) {
                    _this.setState({ sending: false }, function () {
                        if (_this.props.errorHandler) {
                            _this.props.errorHandler(error);
                        }
                        else {
                            // eslint-disable-next-line no-alert
                            alert("Error : " + error);
                        }
                    });
                });
            });
        };
        _this.render = function () {
            var _a, _b;
            return (react_1.default.createElement(SplitDialog_1.default, { open: _this.props.open || false, title: "Change Password", subTitle: _this.props.auditUserEmail || ((_a = _this.state.parsedUser) === null || _a === void 0 ? void 0 : _a.username) || "", maxWidth: "sm", fullWidth: true, dialogContent: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
                        _this.props.passwordAge > 90 && (react_1.default.createElement(core_1.Typography, { color: "error", variant: "h6" }, "Password has expired and must be changed.")),
                        react_1.default.createElement("input", { type: "text", name: "username", value: (_b = _this.state.parsedUser) === null || _b === void 0 ? void 0 : _b.username, style: { display: "none" } }),
                        react_1.default.createElement(core_1.TextField, { type: "password", name: "password", fullWidth: true, margin: "dense", label: "Old Password", onChange: function (evt) {
                                var _a;
                                var _b = evt.target, name = _b.name, value = _b.value;
                                _this.setState((_a = {}, _a[name] = value, _a));
                            } }),
                        react_1.default.createElement(core_1.TextField, { type: "password", label: "New Password", fullWidth: true, margin: "dense", InputProps: {
                                inputProps: {
                                    autoComplete: "new-password"
                                }
                            }, onChange: _this.updateMethod, name: "newPassword", error: !!(_this.state.errors.newPassword &&
                                Object.keys(_this.state).includes("newPassword")), helperText: Object.keys(_this.state).includes("newPassword")
                                ? _this.state.errors.newPassword
                                : "" }),
                        _this.state.newPassword ? (react_1.default.createElement(PasswordStrengthMeter_1.default, { password: _this.state.newPassword || "" })) : (react_1.default.createElement("div", { style: { height: "10px" } })),
                        react_1.default.createElement(core_1.TextField, { type: "password", label: "Confirm New Password", fullWidth: true, margin: "dense", InputProps: {
                                inputProps: {
                                    autoComplete: "new-confirm-password"
                                }
                            }, onChange: _this.updateMethod, name: "confirmPassword", error: !!(_this.state.errors.confirmPassword &&
                                Object.keys(_this.state).includes("confirmPassword")), helperText: Object.keys(_this.state).includes("confirmPassword")
                                ? _this.state.errors.confirmPassword
                                : "" }))), actions: _this.props.passwordAge <= 90
                    ? [
                        react_1.default.createElement(Button_1.default, { key: "cancel", variant: "outlined", onClick: function () {
                                _this.setState({
                                    errors: {}
                                });
                                _this.props.closeMethod();
                            }, disabled: _this.state.sending }, "cancel"),
                        react_1.default.createElement(Button_1.default, { key: "update", variant: "contained", disabled: !_this.state.valid || _this.state.sending, inProgress: _this.state.sending, color: "primary", onClick: _this.submitNewPassword }, "Update")
                    ]
                    : [
                        react_1.default.createElement(Button_1.default, { key: "update", variant: "contained", disabled: !_this.state.valid || _this.state.sending, inProgress: _this.state.sending, color: "primary", onClick: _this.submitNewPassword }, "Update")
                    ] }));
        };
        _this.state = { errors: {} };
        return _this;
    }
    return ChangePassword;
}(react_1.default.Component));
exports.default = ChangePassword;
ChangePassword.propTypes = {
    jwt: prop_types_1.default.string,
    open: prop_types_1.default.bool,
    closeMethod: prop_types_1.default.func,
    errorHandler: prop_types_1.default.func,
    auditUserEmail: prop_types_1.default.string,
    auditUserId: prop_types_1.default.number,
    passwordAge: prop_types_1.default.number
};
